import { useState, useEffect, useMemo } from 'react';

export function useAccumulatedValues<T>(
  data: T[] | undefined,
  mapFn: (item: T) => string
) {
  const [accumulated, setAccumulated] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!data) return;

    const newValues = data.map(mapFn);
    setAccumulated((prev) => new Set([...prev, ...newValues]));
    // mapFn is stable as it's defined inline where useAccumulatedValues is used, we don't expect it to change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return useMemo(() => [...accumulated], [accumulated]);
}
